import React from 'react';
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';
import { compose, withState, withHandlers, branch, lifecycle, renderComponent } from 'recompose';
import PropTypes from 'prop-types';

import { authAdminRequest, authUserRequest, getTokenFromCookies } from '../redux/reducers/login';

import {
  getUserProgramsFullRequest,
  selectUserPrograms,
  selectUserModule,
  selectUserContent,
  selectUserVersion,
} from '../redux/reducers/userProgramsFull';
import {
  learnerVersionsRequest,
  addPathToSaveVersion,
  resetLearnerVersion,
  overwriteVersionRequest,
  saveVersionRequest
} from '../redux/reducers/savedVersions';

import Spinner from '../Components/Spinner';
import authHOC from '../Components/AuthHOC';
import LearnerThinkToolView from './Components/LearnerThinkToolView';
import { getSelectedVersion } from '../redux/selectors';
import { showRatingPopup } from '../redux/reducers/coachRatings';

const LearnerThinkTool = ({ pathForIFrame, onReceiveMessage }) => (
  <LearnerThinkToolView pathForIFrame={pathForIFrame} onReceiveMessage={onReceiveMessage} />
);

LearnerThinkTool.propTypes = {
  pathForIFrame: PropTypes.string,
  onReceiveMessage: PropTypes.func,
};

const mapStateToProps = state => ({
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
  savedVersions: state.savedVersionsReducer,
  version: getSelectedVersion(state),
  view: state.viewReducer,
});

const mapDispatchToProps = dispatch => ({
  getToken: token => dispatch(getTokenFromCookies(token)),
  authUser: () => dispatch(authUserRequest()),
  authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  selectUserPrograms: programId => dispatch(selectUserPrograms(programId)),
  selectUserVersion: versionId => dispatch(selectUserVersion(versionId)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  addPathToSaveVersion: path => dispatch(addPathToSaveVersion(path)),
  resetLearnerVersion: () => dispatch(resetLearnerVersion()),
  overwriteVersionRequest: () => dispatch(overwriteVersionRequest()),
  saveVersionRequest: () => dispatch(saveVersionRequest()),
  showRatingPopup: (bool) => dispatch(showRatingPopup(bool)),
});

export default compose(
   
  withState('pathForIFrame', 'getPathForIFrame', null),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    onReceiveMessage: props => event => {
     
    
      var obj = JSON.parse(event.data)
      console.log('BACK7',obj)
    
      if(obj.action=='BACK'){
            props.history.push('/users/'+props.userProgramsFull.selectedProjectId+'/'+props.userProgramsFull.selectedRollout+'/'+props.userProgramsFull.selectedUserId+'/'+props.userProgramsFull.selectedThinkToolId+ props.history.location.search)
      
      }
      if(obj.action=='COMPLETE'){
        console.log('MMNNBB',props)
        props.history.push('/users/'+props.userProgramsFull.selectedProjectId+'/'+props.userProgramsFull.selectedRollout+'/'+props.userProgramsFull.selectedUserId+'/'+props.userProgramsFull.selectedThinkToolId+ props.history.location.search)
        if(props.version.status!='reviewed'){
          props.showRatingPopup(true)
        }
       
      }
     
    },
  }),
  authHOC,
  lifecycle({
    componentWillMount() {
      
      const {
        userProgramsFull,
        match: { params },
        version,
        getPathForIFrame
      } = this.props;
      console.log('MOUNT VERSION', version)

     
         getPathForIFrame(version.path);
     
        
      

      window.history.pushState(null, null, window.location.href);
      window.onpopstate = () => window.history.go(1);
    },
    componentWillReceiveProps(nextProps) {
      // const {
      //   userProgramsFull,
      //   loginReducer,
      //   getUserProgramsFullRequest,
      //   savedVersions,
      //   getPathForIFrame,
      //   learnerVersionsRequest,
      //   selectedContentItem,
      //   pathForIFrame,
      //   getAllThinkTools,
      //   getAllThinkToolsAndJournals
      // } = nextProps;

      // if (
      //   savedVersions.isFetched === false &&
      //   savedVersions.fetching === false &&
      //   loginReducer.user !== null &&
      //   loginReducer.user.userId
      // ) {
      //   learnerVersionsRequest();
      // }
      // if (loginReducer.user !== null && userProgramsFull.programs === null) {
      //   if (!userProgramsFull.isFetched && !userProgramsFull.fetching) {
      //     getUserProgramsFullRequest();
      //   }
      // }
      
      // if (userProgramsFull.selectedUserVersion !== null && savedVersions.learnerVersions) {
      //   if (selectedContentItem) {
      //     if (selectedContentItem.type!='ThinkTool') {
      //       selectedContentItem.path
      //       }
      //   }
      // }
      // if (userProgramsFull.selectedUserVersion === null) {
      //   if (getAllThinkToolsAndJournals && !pathForIFrame) {
      //     console.log('SHAUNPATH4', getAllThinkToolsAndJournals.find(
      //       content => content.contentId === userProgramsFull.selectedContentId,
      //     ).path)
      //     getPathForIFrame(
      //       getAllThinkToolsAndJournals.find(
      //         content => content.contentId === userProgramsFull.selectedContentId,
      //       ).path,
      //     );
      //   }
      // }
    },
  }),
  branch(
    props => !props.loginReducer.isLoggedIn && !props.userProgramsFull.isFetched,
    renderComponent(Spinner),
  ),
)(LearnerThinkTool);



// WEBPACK FOOTER //
// ./src/Screens/LearnerThinkTool.jsx